import React, { Suspense, useState } from "react";
import { Spinner } from "@/components/ui/spinner";
import OpportunitiesAggregatedSavings from "@/opportunity/OpportunitiesAggregatedSavings";
import { Card } from "@/components/ui/card";
import { XIcon } from "lucide-react";
import BuildingGraphic from "@/assets/skyline_transparent.png";

export const OpportunityAggregatedSavingsCard = () => {

  const [hidden, setHidden] = useState(false);

  if (hidden) return;

  return (
    <Card className="p-6 relative overflow-hidden">
      <button className="absolute top-2 right-2 p-1 bg-gray-100 hover:bg-gray-200 rounded-md text-gray-500 z-10" onClick={() => setHidden(true)}>
        <XIcon size={16}/>
      </button>
      <Suspense fallback={<Spinner/>}>
        <OpportunitiesAggregatedSavings/>
      </Suspense>
      <img
        src={BuildingGraphic}
        alt="Building Graphic"
        className="absolute -translate-y-1/4 translate-x-1/4 right-0 max-w-[50%] w-2/3 overflow-hidden z-0"
      />
    </Card>
  )
}